/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */
import FormItem from "@/core/modules/coach/Resources/Forms/model/FormItem";

export default class FormAnswerItem extends FormItem {

	formId: string = null
	teamMemberId: string = null

	constructor() {
		super();
	}


}
